var testidSeparators = {
  EXPERIMENTS_SEPARATOR: '^',
  KBB_TESTID_VARIATION_SEPARATOR: '_',
  PE_TESTID_VARIATION_SEPARATOR: '-'
};
var getTestAndVariationValue = function getTestAndVariationValue(testAndVariation, separator) {
  var gaTestAndVariation = testAndVariation === null || testAndVariation === void 0 ? void 0 : testAndVariation.split(separator);
  if (gaTestAndVariation && gaTestAndVariation.length === 2 && gaTestAndVariation[0] && gaTestAndVariation[1]) {
    return gaTestAndVariation.join('::').toLowerCase();
  }
  return null;
};
export var getExperimentIds = function getExperimentIds(testIds) {
  if (!testIds || typeof testIds !== 'string') {
    return [];
  }
  var experiments = testIds.split(testidSeparators.EXPERIMENTS_SEPARATOR).map(function (testAndVariation) {
    return getTestAndVariationValue(testAndVariation, testidSeparators.PE_TESTID_VARIATION_SEPARATOR) || getTestAndVariationValue(testAndVariation, testidSeparators.KBB_TESTID_VARIATION_SEPARATOR);
  }).filter(function (testAndVariation) {
    return testAndVariation;
  });
  if (experiments && experiments.length > 0) {
    return experiments;
  }
  return [];
};